import { Grid, Typography } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import { getSlideById } from "../../../learning-path/learningPath.service";
import { useStyles } from "./lesson-collectible-detail.style";

interface LessonCollectibleDetailProps {
  slideId: number;
}

const LessonCollectibleDetail = ({ slideId }: LessonCollectibleDetailProps) => {
  const classes = useStyles();

  const { data, isLoading } = useQuery({
    queryKey: ["lesson-collectible/slide", slideId],
    queryFn: () => getSlideById(slideId),
    refetchOnWindowFocus: false,
  });

  const renderSlide = () => {
    return (
      <Grid container className={classes.introDetails}>
        <Grid item lg={5} xs={5}>
          <img src={data?.imagePath} />
        </Grid>
        <Grid item lg={7} xs={7}>
          <Typography variant="h6" className={classes.intro}>
            {data?.title}
          </Typography>
          <p className={classes.body}>{data?.body}</p>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {isLoading && <span>Loading...</span>}
      {data && (
        <Grid container>
          <Grid item md={12}>
            {renderSlide()}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default LessonCollectibleDetail;
